import { datadogRum } from "@datadog/browser-rum";
import { AxiosError } from "axios";
import { removeLoadingState } from "PFCore/initializers/remove_loading_state";
import { ErrorInfo, PropsWithChildren } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import { useMount } from "react-use";

export const CurrentAccountErrorBoundary = ({ children }: PropsWithChildren) => {
  const handleError = (error: Error, errorInfo: ErrorInfo) => {
    if (datadogRum) {
      datadogRum.addError(error, errorInfo);
    }
  };
  return (
    <ErrorBoundary onError={handleError} FallbackComponent={FallbackComponent}>
      {children}
    </ErrorBoundary>
  );
};

const DisplayServerError = () => {
  const { t } = useTranslation();
  useMount(() => {
    removeLoadingState();
  });
  return <p>{t("internalServerError")}</p>;
};

const FallbackComponent = ({ error }) => {
  if (!error || !("status" in error)) {
    throw error; // rethrow as this error boundary handles only fetching error
  }
  if ((error as AxiosError).status === 404) {
    window.location.replace("https://profinda.com");
  } else {
    return <DisplayServerError />;
  }
};
